<script>
export default {
  props: {
      title: String,
      indent: { type: Number, default: 0 }
  },

    computed: {
        groupClass() {
            return `group indent-${this.indent}`;
        }
    },

}
</script>

<template>
  <div :class="groupClass">
    <div v-if="title" class="title">
        <span>{{ title }}</span>
        <slot name="title-extra" />
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.group {
  margin-bottom: 10px;

  /* グループごとに囲みたい場合は下記をコメントアウト */

  /* border: 1px solid #ddd;
  border-radius: 4px; */
}

.indent-0 {
    padding-left: 0;
}

.indent-1 {
    padding-left: 20px;
}

.indent-2 {
    padding-left: 40px;
}

.indent-3 {
    padding-left: 60px;
}

.indent-4 {
    padding-left: 80px;
}

.title {
  padding: 10px;
  margin: 10px 0;
  font-weight: bold;
  background-color: #f0f0f0;

  /* タイトルの下に下線が欲しい場合は下記をコメントアウト */

  /* border-bottom: 1px solid #ccc; */
}

.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
